import { NO_ANSWER } from 'app/config/app'
import { ItemWithQuestionChoice } from '../../types'

export function InputItemChoice({
  item,
  index,
}: {
  item: ItemWithQuestionChoice
  index: number
}) {
  const resolveValue = () =>
    item.questionItem.question.choiceQuestion?.value || NO_ANSWER

  return <span className={`index-${index}`}>{resolveValue()}</span>
}
